import axios from 'axios';
import { getToken } from './auth';

const api = axios.create({
  baseURL: '', // relative to current origin
});

// Universal loader logic
let loader;
function getLoader() {
  if (!loader) {
    // Dynamically import to avoid circular dependency
    loader = require('../contexts/LoaderContext');
  }
  return loader;
}

api.interceptors.request.use(config => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  try {
    const { showLoader } = getLoader().useLoader();
    showLoader && showLoader();
  } catch {}
  return config;
});

api.interceptors.response.use(
  response => {
    try {
      const { hideLoader } = getLoader().useLoader();
      hideLoader && hideLoader();
    } catch {}
    return response;
  },
  error => {
    try {
      const { hideLoader } = getLoader().useLoader();
      hideLoader && hideLoader();
    } catch {}
    return Promise.reject(error);
  }
);

export const apiGet = (url, config = {}) => api.get(process.env.REACT_APP_APIURL+url, config);
export const apiPost = (url, data, config = {}) => api.post(process.env.REACT_APP_APIURL+url, data, config);
export const apiPut = async (url, data, config = {}) => {
  const targetUrl = `${process.env.REACT_APP_APIURL || ''}${url}`;
  const forcePostUpdate = String(process.env.REACT_APP_FORCE_POST_UPDATE || '').toLowerCase() === 'true';

  if (forcePostUpdate) {
    return api.post(`${targetUrl}/update`, data, config);
  }

  try {
    return await api.put(targetUrl, data, config);
  } catch (error) {
    // Fallback for servers/proxies that reject PUT with 405.
    if (error?.response?.status === 405) {
      const separator = targetUrl.includes('?') ? '&' : '?';
      const fallbackUrl = `${targetUrl}${separator}_method=PUT`;
      const headers = {
        ...(config.headers || {}),
        'X-HTTP-Method-Override': 'PUT',
      };
      try {
        return await api.post(
          fallbackUrl,
          { ...(data || {}), _method: 'PUT' },
          { ...config, headers }
        );
      } catch (postError) {
        // Additional compatibility path for APIs exposing POST /:id/update.
        if (postError?.response?.status === 404 || postError?.response?.status === 405) {
          return api.post(`${targetUrl}/update`, data, config);
        }
        throw postError;
      }
    }
    throw error;
  }
};
export const apiDelete = async (url, config = {}) => {
  const targetUrl = `${process.env.REACT_APP_APIURL || ''}${url}`;
  const forcePostUpdate = String(process.env.REACT_APP_FORCE_POST_UPDATE || '').toLowerCase() === 'true';

  if (forcePostUpdate) {
    return api.post(`${targetUrl}/delete`, {}, config);
  }

  try {
    return await api.delete(targetUrl, config);
  } catch (error) {
    // Fallback for servers/proxies that reject DELETE with 405.
    if (error?.response?.status === 405) {
      try {
        return await api.post(`${targetUrl}/delete`, {}, config);
      } catch (postError) {
        throw postError;
      }
    }
    throw error;
  }
};

export default api; 